var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2385_9513)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.66699,
    cy: 9,
    r: 8.5,
    fill: "#99D6A2",
    stroke: "#3AB54A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33119 15V3H10.1411V15H9.33119ZM11.4793 6.96094C11.4398 6.58281 11.2703 6.28906 10.9707 6.07969C10.6711 5.87031 10.2645 5.76562 9.75094 5.76562C9.40197 5.76562 9.10732 5.8125 8.86699 5.90625C8.62666 5.99688 8.4423 6.12344 8.31391 6.28594C8.1888 6.44844 8.12625 6.63281 8.12625 6.83906C8.11967 7.01094 8.15753 7.16094 8.23983 7.28906C8.32543 7.41719 8.4423 7.52813 8.59045 7.62188C8.7386 7.7125 8.90979 7.79219 9.10403 7.86094C9.29827 7.92656 9.50568 7.98281 9.72625 8.02969L10.6349 8.23594C11.076 8.32969 11.481 8.45469 11.8497 8.61094C12.2184 8.76719 12.5378 8.95937 12.8077 9.1875C13.0777 9.41562 13.2867 9.68437 13.4349 9.99375C13.5863 10.3031 13.6637 10.6578 13.667 11.0578C13.6637 11.6453 13.5057 12.1547 13.1929 12.5859C12.8835 13.0141 12.4357 13.3469 11.8497 13.5844C11.267 13.8187 10.5641 13.9359 9.74107 13.9359C8.92461 13.9359 8.21349 13.8172 7.60773 13.5797C7.00526 13.3422 6.53448 12.9906 6.19539 12.525C5.85958 12.0562 5.68345 11.4766 5.66699 10.7859H7.73613C7.75917 11.1078 7.85629 11.3766 8.02749 11.5922C8.20197 11.8047 8.43407 11.9656 8.72378 12.075C9.01679 12.1812 9.34765 12.2344 9.71637 12.2344C10.0785 12.2344 10.3929 12.1844 10.6596 12.0844C10.9295 11.9844 11.1386 11.8453 11.2867 11.6672C11.4349 11.4891 11.509 11.2844 11.509 11.0531C11.509 10.8375 11.4415 10.6562 11.3065 10.5094C11.1748 10.3625 10.9806 10.2375 10.7238 10.1344C10.4703 10.0312 10.1592 9.9375 9.79045 9.85312L8.68921 9.59062C7.83654 9.39375 7.16329 9.08594 6.66946 8.66719C6.17563 8.24844 5.93037 7.68437 5.93366 6.975C5.93037 6.39375 6.09333 5.88594 6.42255 5.45156C6.75506 5.01719 7.21103 4.67813 7.79045 4.43438C8.36987 4.19063 9.02831 4.06875 9.76576 4.06875C10.5164 4.06875 11.1715 4.19063 11.7312 4.43438C12.2942 4.67813 12.732 5.01719 13.0448 5.45156C13.3575 5.88594 13.5188 6.38906 13.5287 6.96094H11.4793Z",
    fill: "#12751F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.667,
    cy: 15,
    r: 5,
    fill: "#3AB54A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0596 15.0092L15.3602 16.9346L18.2859 13.0654",
    stroke: "white",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2385_9513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.666992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaid);
export default __webpack_public_path__ + "static/media/icon-paid.11df9811b97df1669103e1b15426ac6a.svg";
export { ForwardRef as ReactComponent };